
var chuli = function(num){
  if(num<10){
    return "0" + num
  }else{
    return num
  }
}

var option = {
  year: function(time) {
    var time = new Date(time)
    var year = time.getFullYear()
    var month = time.getMonth() + 1 > 9 ? time.getMonth() + 1 : 0 + (time.getMonth() + 1)
    // var date= time.getDate() > 9 ? time.getDate() : 0 + time.getDate()
    // var hour = time.getHours() > 9 ? time.getHours() : 0 + time.getHours()
    // var minute = time.getMinutes() > 9 ? time.getMinutes() : 0 + time.getMinutes()
    // var second = time.getSeconds() > 9 ? time.getSeconds() : 0 + time.getMinutes()
    return chuli(year) + "-" + chuli(month)

  },
  ymd: function(time) {
    var time = new Date(time)
    var year = time.getFullYear()
    var month = time.getMonth() + 1 > 9 ? time.getMonth() + 1 : 0 + (time.getMonth() + 1)
    var date= time.getDate() > 9 ? time.getDate() : 0 + time.getDate()

    return chuli(year) + "-" + chuli(month) + "-" + chuli(date)
  },
  day: function(time) {
    var time = new Date(time)
    var year = time.getFullYear()
    var month = time.getMonth() + 1 > 9 ? time.getMonth() + 1 : 0 + (time.getMonth() + 1)
    var date= time.getDate() > 9 ? time.getDate() : 0 + time.getDate()
    // var hour = time.getHours() > 9 ? time.getHours() : 0 + time.getHours()
    // var minute = time.getMinutes() > 9 ? time.getMinutes() : 0 + time.getMinutes()
    // var second = time.getSeconds() > 9 ? time.getSeconds() : 0 + time.getMinutes()
    return chuli(date)
  },
  month: function(time) {
    var time = new Date(time)
    var year = time.getFullYear()
    var month = time.getMonth() + 1 > 9 ? time.getMonth() + 1 : 0 + (time.getMonth() + 1)
    var date= time.getDate() > 9 ? time.getDate() : 0 + time.getDate()
    // var hour = time.getHours() > 9 ? time.getHours() : 0 + time.getHours()
    // var minute = time.getMinutes() > 9 ? time.getMinutes() : 0 + time.getMinutes()
    // var second = time.getSeconds() > 9 ? time.getSeconds() : 0 + time.getMinutes()
    return chuli(year) + "-" + chuli(month) + "-" + chuli(date)
  },
  complete: function(time) {
    var time = new Date(time)
    var year = time.getFullYear()
    var month = time.getMonth() + 1 > 9 ? time.getMonth() + 1 : 0 + (time.getMonth() + 1)
    var date= time.getDate() > 9 ? time.getDate() : 0 + time.getDate()
    var hour = time.getHours() > 9 ? time.getHours() : 0 + time.getHours()
    var minute = time.getMinutes() > 9 ? time.getMinutes() : 0 + time.getMinutes()
    var second = time.getSeconds() > 9 ? time.getSeconds() : 0 + time.getMinutes()

    return chuli(year) + "-" + chuli(month) + "-" + chuli(date) + "  " + chuli(hour) + ":" + chuli(minute) + ":" + chuli(second)

  },

  tothisTop: function(el){
    let els = document.getElementById(el)
    window.scrollTo(0,els.offsetTop-75)
  },

  animateScroll: function(el){
    let els = document.getElementById(el)
    let i = 0
    console.log(els.offsetTop)
    var scroll = setInterval(() => {
      i = i + 15
      if(i > els.clientHeight){
        clearInterval(scroll)
        return
      }
      window.scrollTo(0, i - 71)
    },1)
  },

  self_blank: function(routeData){
    if(document.documentElement.clientWidth <= 768){
      window.open(routeData.href, "_self");
    }else if(document.documentElement.clientWidth > 768){
      window.open(routeData.href, "_blank");
    }
  },

  to_path: function(path, ch){
    this.$router.push({
      path: '/content',
      query: {
        ch: ch
      }
    })
  }
}

export {
  option
}



// WEBPACK FOOTER //
// ./src/public/public.js